import React from 'react';
import { connect } from 'react-redux';

import ImageLoader from '@starbucks-web/pattern-library/lib/components/image-loader';

import { configImagesUrlSelector } from 'shared/app/state/selectors/config';

import { usePdpContext } from '../pdp-provider';

import styles from './styles.cssm';

export const BEVERAGE_IMAGE_POLICY = '1by1_wide_topcrop_630';
export const FOOD_AND_PACKAGED_IMAGE_POLICY = '1by1_medium_630';
export const LEGACY_IMAGE_POLICY = '1by1_wide_640';

export const akamaiImagePolicy = (product) => {
  let imagePolicy = '';
  const productType = (product?.productType || '').toLowerCase();
  const formCode = (product?.formCode || '').toLowerCase();
  if (
    (productType === 'beverages' && formCode === 'packaged') ||
    productType === 'coffees' ||
    productType === 'food'
  ) {
    imagePolicy = FOOD_AND_PACKAGED_IMAGE_POLICY;
  } else if (productType === 'beverages') {
    imagePolicy = BEVERAGE_IMAGE_POLICY;
  }
  return imagePolicy;
};

export const ProductImage = ({ imagesUrl }) => {
  const { product } = usePdpContext();

  const getImageSrc = () => {
    if (product?.loading) {
      // Because we rely on knowing the product type and formCode to fetch an optimized
      // image from Akamai, don't try to render the image until the product is loaded.
      // If we don't return early, the PDP will load with the unoptimized image first,
      // and then re-render when the optimized image url is calculated, causing a
      // slightly jarring layout shift in many cases, and an extra flash of the
      // image loading state.
      return null;
    }
    const masterImageUri = product?.imageURL;

    if (!masterImageUri) {
      return null;
    }
    return `${masterImageUri}?impolicy=${akamaiImagePolicy(product)}`;
  };

  return (
    <ImageLoader
      alt=""
      includeFallback={{
        enabled: true,
        wrapperClassName: `${styles.imageMask}`,
      }}
      lazyLoad={{ enabled: false }}
      placeholder={{
        src: `${imagesUrl}/product-placeholder.png`,
      }}
      src={getImageSrc()}
      wrapInFlex={{
        enabled: true,
        flexEmbedWrapperClassName: `${styles.imageBlock} mx-auto`,
      }}
    />
  );
};

const select = (state) => ({
  imagesUrl: configImagesUrlSelector(state),
});

export default connect(select, null)(ProductImage);
